import {Inject, Injectable} from "@angular/core";
import {ActionService, ConfigurationService, JwtHttpClientService, ResourceModule} from "@fedeltapointofsale/data-client";

export class AppLayoutImportItem {
    name: string;

    description: string;

    price: number;

    imageUrl: string;

    /**
     * Unique reference to correlate import status
     */
    importRef: string;

    status: string;
}

export enum ImportCategoryType {
    NONE = <any>"None",
    FOOD = <any>"Food",
    BEVERAGE = <any>"Beverages"
}

export class AppLayoutImportCategory {
    name: string;
    items: AppLayoutImportItem[] = [];
    topCategory: ImportCategoryType;
    imageUrl: string;
}

export class AppLayoutImportDetails {
    categories: AppLayoutImportCategory[] = [];
}

export class AppLayoutImportAction {
    constructor(public data?: string, public parseOnly?: boolean, public appLayout?: AppLayoutImportDetails) {
    }
}

/**
 * Action Service to import app layout
 */
@Injectable()
export class AppLayoutImportService extends ActionService {
    constructor(http: JwtHttpClientService,
                configService: ConfigurationService,
                @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) nameSpace,
                @Inject(ResourceModule.ACTION_NAMES_KEY) actionNames) {
        super(http, configService, nameSpace, actionNames, "app-layout-import");
    }
}
